import { render, staticRenderFns } from "./FilterBaths.vue?vue&type=template&id=6079a622&"
import script from "./FilterBaths.vue?vue&type=script&lang=js&"
export * from "./FilterBaths.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports